import { Contract } from "src/shared/models/contract.model";

export const ContractSerializer = {
  fromJson(json: any): Contract {
    return new Contract(json);
  },

  fromJsonList(json: any[]): Contract[] {
    return json.map((item) => new Contract(item));
  },
};